export function isWorkerScope(scope) {
    return typeof WorkerGlobalScope !== "undefined" && scope instanceof WorkerGlobalScope;
}
export function assertWorkerScope(scope) {
    if (!isWorkerScope(scope))
        throw new Error("Not in a WebWorker");
}
export function isDedicatedWorkerScope(scope) {
    return typeof DedicatedWorkerGlobalScope !== "undefined" && scope instanceof DedicatedWorkerGlobalScope;
}
export function isSharedWorkerScope(scope) {
    return typeof SharedWorkerGlobalScope !== "undefined" && scope instanceof SharedWorkerGlobalScope;
}
export function assertSharedWorkerScope(scope) {
    if (!isSharedWorkerScope(scope))
        throw new Error("Not in a shared web worker");
}
export function isSharedWorkerContext(context) {
    return context instanceof MessagePort;
}
